var map = {
	"./envelope02en.png": "e+8E",
	"./envelope02khm.png": "+NWg",
	"./envelope02thai.png": "7dMv",
	"./envelope02vi.png": "MpkK",
	"./envelope02zh-tw.png": "9CXl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GvyH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img ^\.\/envelope02.*\.png$
// module id = GvyH
// module chunks = 1